export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_LEFT = 'ArrowLeft';
export const ENTER = 'Enter';
export const BACKSPACE = 'Backspace';
export const CLEAR = 'Clear';
export const TAB_CHAR = '\u0009';
